import {fork, cancel} from 'redux-saga/effects';
import {memoize} from 'helpers';

export function* runWhile(saga, on) {
  const task = getTask(saga);
  if (on && !task.current) {
    task.current = yield fork(saga);
  } else if (!on && task.current) {
    task.current = yield cancel(task.current);
  }
}

const getTask = memoize(() => ({ current: null }));
